/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseRegistAmazonItemsResponse } from './ResponseRegistAmazonItemsResponse';
import {
    ResponseRegistAmazonItemsResponseFromJSON,
    ResponseRegistAmazonItemsResponseFromJSONTyped,
    ResponseRegistAmazonItemsResponseToJSON,
    ResponseRegistAmazonItemsResponseToJSONTyped,
} from './ResponseRegistAmazonItemsResponse';

/**
 * 
 * @export
 * @interface ResponseBulkRegisterAmazonItemsResponse
 */
export interface ResponseBulkRegisterAmazonItemsResponse {
    /**
     * 
     * @type {Array<ResponseRegistAmazonItemsResponse>}
     * @memberof ResponseBulkRegisterAmazonItemsResponse
     */
    items?: Array<ResponseRegistAmazonItemsResponse>;
}

/**
 * Check if a given object implements the ResponseBulkRegisterAmazonItemsResponse interface.
 */
export function instanceOfResponseBulkRegisterAmazonItemsResponse(value: object): value is ResponseBulkRegisterAmazonItemsResponse {
    return true;
}

export function ResponseBulkRegisterAmazonItemsResponseFromJSON(json: any): ResponseBulkRegisterAmazonItemsResponse {
    return ResponseBulkRegisterAmazonItemsResponseFromJSONTyped(json, false);
}

export function ResponseBulkRegisterAmazonItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBulkRegisterAmazonItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ResponseRegistAmazonItemsResponseFromJSON)),
    };
}

export function ResponseBulkRegisterAmazonItemsResponseToJSON(json: any): ResponseBulkRegisterAmazonItemsResponse {
    return ResponseBulkRegisterAmazonItemsResponseToJSONTyped(json, false);
}

export function ResponseBulkRegisterAmazonItemsResponseToJSONTyped(value?: ResponseBulkRegisterAmazonItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ResponseRegistAmazonItemsResponseToJSON)),
    };
}

